export const IINFieldKeyFactory = (passengerID) => `IIN_${passengerID}`;
